/**
 * Created by csaba.adam on 2017. 07. 14..
 */
import languages from '../../languages/index';

const DEFAULT_LANGUAGE = 'hu';
const LANGUAGE_COOKIE = 'language';
const REDUNDANT_TYPES = ['locationTypes']
export class NiceUrlService {
	constructor($http, $cookies) {
		'ngInject';
		this.$http = $http;
		this.$cookies = $cookies;
	}

	createNiceUrl(formData) {
		let currentLanguage = this.$cookies.get(LANGUAGE_COOKIE) ? this.$cookies.get(LANGUAGE_COOKIE) : DEFAULT_LANGUAGE;
		let returnString = '#/';
		// this.languages = {};
		this.niceUrlObject = this.createNiceUrlObject(formData, currentLanguage);
		for (let niceUrlObjectKey in this.niceUrlObject) {
			returnString += niceUrlObjectKey + '=' + this.niceUrlObject[niceUrlObjectKey] + '/';
		}
		return returnString;
	}

	createNiceUrlObject(formData, currentLanguage) {
		currentLanguage = currentLanguage || this.$cookies.get(LANGUAGE_COOKIE) ? this.$cookies.get(LANGUAGE_COOKIE) : DEFAULT_LANGUAGE;
		let currentLanguageValues = languages[currentLanguage].anyitNiceUrl;
		let resultObject = {};
		for (let key in formData) {
			if (currentLanguageValues.keys.hasOwnProperty(key)) {
				if (typeof formData[key] == 'object' && formData[key] !== null) {
					if (formData[key].length) { // ha tömb jön legalább 1 elemmel
						let result = '';
						let resultStrings = [];
						for (let i = 0; i < formData[key].length; ++i) {
							let currentString = currentLanguageValues.values.hasOwnProperty(key) ?
								currentLanguageValues.values[key][formData[key][i]] :
								formData[key][i];
							if (typeof currentString != "undefined" && (REDUNDANT_TYPES.indexOf(key) != -1 || resultStrings.indexOf(currentString) == -1)) { // azért undefinedra vizsgálunk, mert 0 számként jöhet
								result += currentString;
								resultStrings.push(currentString);
								if (i != formData[key].length - 1) {
									result += '&';
								}
							}

						}
						if (result[result.length - 1] == '&') {
							result = result.slice(0, -1);
						}
						resultObject[currentLanguageValues.keys[key]] = result;
					}
				} else if (resultObject.hasOwnProperty(currentLanguageValues.keys[key])) { // intervallumok alsó és felsőhatára külön propertyből jön
					let value = '';
					if (formData[key] !== null) {
						if (currentLanguageValues.values.hasOwnProperty(key)) {
							value = currentLanguageValues.values[key][formData[key]];
						} else {
							value = formData[key];
						}
					}
					if (key.endsWith('Min')) {
						resultObject[currentLanguageValues.keys[key]] = value + '~' + resultObject[currentLanguageValues.keys[key]];
					} else {
						resultObject[currentLanguageValues.keys[key]] += '~' + value;
					}
				} else {
					let value = currentLanguageValues.values.hasOwnProperty(key) ? currentLanguageValues.values[key][formData[key]] : formData[key];
					value = value === null || typeof value == "undefined" ? '' : value;
					// ===, mert '' == 0 IGAZ
					if (value || value === 0 || value === "0" || value == '') {
						resultObject[currentLanguageValues.keys[key]] = value;
					}
				}
			}
		}
		return resultObject;
	}

	preLoadDataFromNiceUrl(hash, currentLanguage) {
		currentLanguage = currentLanguage || this.$cookies.get(LANGUAGE_COOKIE) ? this.$cookies.get(LANGUAGE_COOKIE) : DEFAULT_LANGUAGE;
		let currentLanguageValues = languages[currentLanguage].anyitNiceUrl;
		let resultObject = {};
		if (/#\/.+/.test(hash)) {
			let hashRemoved = hash.substring(1);
			let splitted = hashRemoved.split('/');
			let splittedSplitted = [];
			for (let k = 0; k < splitted.length; ++k ) {
				let item = splitted[k];
				if (item) {
					splittedSplitted.push(item.split('='));
				}
			}
			for (let l = 0; l < splittedSplitted.length; ++l ){
				let item = splittedSplitted[l];
				let key = item[0];
				let value = item[1];
				if (currentLanguageValues.keysBack.hasOwnProperty(key)) {
					if (typeof currentLanguageValues.keysBack[key] == 'object' && /.*~.*/.test(value)) { // ranges esetek ~
						let splitByTilda = item[1].split('~');
						for (let i = 0; i < splitByTilda.length; ++i) {
							if (currentLanguageValues.keysBack[currentLanguageValues.keysBack[key][i]]) {
								resultObject[currentLanguageValues.keysBack[key][i]] =
									currentLanguageValues.values[currentLanguageValues.keysBack[key][i]].indexOf(splitByTilda[i]);
							} else {
								resultObject[currentLanguageValues.keysBack[key][i]] =
									isNaN(parseFloat(splitByTilda[i])) ?
										splitByTilda[i] :
										parseFloat(splitByTilda[i]);
							}
						}
					} else { // egy kulcs több értékkel, visszamappeléshez
						let resultArray = [];
						let splittedByAndSign = value == 'lakas&haz' ? ['lakas&haz'] : value.split('&');
						for (let i = 0; i < splittedByAndSign.length; i++) {
							let tmp = decodeURI(splittedByAndSign[i]);
							splittedByAndSign[i] = tmp;
						}
						let keyback = currentLanguageValues.keysBack[key];
						if (currentLanguageValues.values.hasOwnProperty(keyback)) { // ha van vissza mappeles
							for (let u = 0; u < splittedByAndSign.length; ++u) {
								let splittedString = splittedByAndSign[u];
								if (currentLanguageValues.values[keyback] && currentLanguageValues.values[keyback].length) { // ha tömb
									resultArray.push(currentLanguageValues.values[keyback].indexOf(splittedString));
								} else { // ha objektum
									for (let valueKey in currentLanguageValues.values[keyback]) {
										if (splittedString == currentLanguageValues.values[keyback][valueKey]) {
											resultArray.push(valueKey);
										}
									}
								}
							}
						} else {
							resultArray = splittedByAndSign;
						}
						resultObject[currentLanguageValues.keysBack[key]] = resultArray;
					}
				}
			}
		}
		return resultObject;
	}
}
